export const oidcConfig = {
  authority: "https://your-identity-provider.com",
  client_id: "your-client-id",
  redirect_uri: window.location.origin + "/callback",
  post_logout_redirect_uri: window.location.origin,
  response_type: "code",
  scope: "openid profile email",
};